import React from 'react';

const EmailIcon = ({ color = '#424242', width = 20, height = 21, ...rest }, ref) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
      ref={ref}>
      <path
        d="M1.66797 10.4987C1.66797 7.356 1.66797 5.78465 2.64428 4.80834C3.62059 3.83203 5.19194 3.83203 8.33464 3.83203H11.668C14.8107 3.83203 16.382 3.83203 17.3583 4.80834C18.3346 5.78465 18.3346 7.356 18.3346 10.4987C18.3346 13.6414 18.3346 15.2127 17.3583 16.1891C16.382 17.1654 14.8107 17.1654 11.668 17.1654H8.33463C5.19194 17.1654 3.62059 17.1654 2.64428 16.1891C1.66797 15.2127 1.66797 13.6414 1.66797 10.4987Z"
        stroke={color}
        strokeWidth="1.25"
      />
      <path
        d="M5 7.16797L6.79908 8.6672C8.32961 9.94264 9.09488 10.5804 10 10.5804C10.9051 10.5804 11.6704 9.94264 13.2009 8.6672L15 7.16797"
        stroke={color}
        strokeWidth="1.25"
        strokeLinecap="round"
      />
    </svg>
  );
};

export default React.forwardRef(EmailIcon);
